import { companyPaymentGatewaysConstants } from '../_constants';

const initialState = {
  paymentGateways: [],
  isLoading: false,
  error: null,

  availablePaymentGateways: [],
  webhooks: [],

  paymentMethods: [],
  chargeStatus: [],
};

export function companyPaymentGateways(state = initialState, action) {
  switch (action.type) {
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_SUCCESS:
      return {
        ...state,
        paymentGateways: action.payload.paymentGateways,
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_SUCCESS:
      return {
        ...state,
        paymentGateways: [...state.paymentGateways, action.payload],
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_UPDATE_SUCCESS:
      return {
        ...state,
        paymentGateways: (state.paymentGateways || []).map(gateway =>
          gateway.id === action.payload.id ? action.payload : gateway,
        ),
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_DELETE_SUCCESS:
      return {
        ...state,
        paymentGateways: state.paymentGateways.filter(
          gateway => gateway.id !== action.payload.id,
        ),
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_SUCCESS:
      return {
        ...state,
        availablePaymentGateways: action.payload.paymentGateways,
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_SUCCESS:
      return {
        ...state,
        webhooks: action.payload.webhooks,
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // Create webhook
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_SUCCESS:
      return {
        ...state,
        webhooks: [...state.webhooks, action.payload.webhook],
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // Update webhook
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_SUCCESS:
      return {
        ...state,
        webhooks: (state.webhooks || []).map(webhook =>
          webhook.id === action.payload.webhook.id ? action.payload.webhook : webhook,
        ),
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // Delete webhook
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_SUCCESS:
      return {
        ...state,
        webhooks: state.webhooks.filter(webhook => webhook.id !== action.payload.id),
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // Charge Status
    case companyPaymentGatewaysConstants.COMPANY_CHARGE_STATUS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_CHARGE_STATUS_FETCH_SUCCESS:
      return {
        ...state,
        chargeStatus: action.payload.chargeStatus,
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_CHARGE_STATUS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // Payment Methods
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_SUCCESS:
      return {
        ...state,
        paymentMethods: action.payload.paymentMethods,
        isLoading: false,
        error: null,
      };
    case companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
